// extracted by mini-css-extract-plugin
export var button = "_fb-4";
export var hasDarkBackground = "_fb-7";
export var hasLightBackground = "_fb-6";
export var iconWrapper = "_fb-0";
export var large = "_fb-2";
export var medium = "_fb-1";
export var small = "_fb-5";
export var xsmall = "_fb-3";